// §25.3 / §9.1 — 2048 as an in-process app.
//
// The first **gated** title (D-200): `requiresAuth: true`, so it is absent from a guest's
// launcher, search, bar and Store rather than shown locked. Solitaire is the deliberate exception,
// not the pattern.
//
// Manifest only (D-247) — the engine, the view and `game2048.css` live behind the `import()`.
import type { InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export const game2048App: InProcessApp = createLazyApp({
  app: {
    id: '2048',
    name: '2048',
    icon: { glyph: 'grid-3x3', hue: 25 },
    keywords: ['2048', 'tiles', 'merge', 'puzzle', 'game', 'arcade'],
    category: 'Arcade',
    // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
    group: 'Boards',
    requiresAuth: true,
    window: { width: 560, height: 720, minWidth: 360, minHeight: 520, multiWindow: false },
    jumpList: [
      { id: 'new-game', label: 'New game' },
      { id: 'undo', label: 'Undo' },
    ],
  },
  load: () => import('./Game2048'),
});
